'use client'
import type { PropsWithChildren } from 'react'

const VaultRolesLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="gap-sm flex flex-col">
      <span className="text-foreground text-sm">Vault Roles</span>
      {children}
    </div>
  )
}

export default VaultRolesLayout
